<!-- Start::Header (the top bar) -->
<div class="layout-topbar">
  <div class="layout-topbar-logo-container">
    <button type="button" class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()"
      aria-label="Menu" [attr.aria-expanded]="layoutService.isMenuOpen()">
      <i class="ui-burger" [class.is-open]="layoutService.isMenuOpen()" aria-hidden="true"><i class="ui-bar"></i><i
          class="ui-bar"></i><i class="ui-bar"></i></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/organizations" aria-label="Home">
      <img [src]="themeSettings.theme().logo" alt="Biz360" class="ui-logo" />
      <span>Master Admin</span>
    </a>
  </div>

  <div class="layout-topbar-actions">
    <button type="button" class="layout-topbar-action" (click)="openSearch()" aria-label="Search" title="Search">
      <i class="pi pi-search"></i>
    </button>
    <!-- Language: the current flag opens the list (English / Arabic), as in the tenant portal. -->
    <button #languageButton type="button" class="layout-topbar-action ui-lang-btn" (click)="languageMenu.toggle($event)"
      aria-label="Language" aria-haspopup="listbox" [attr.aria-expanded]="languageMenu.overlayVisible"
      [title]="currentLanguage().name">
      <img [src]="currentLanguage().flag" [alt]="currentLanguage().name + ' flag'" class="ui-lang-flag" />
    </button>
    <p-popover #languageMenu appendTo="body" styleClass="ui-lang-panel">
      <ul class="ui-lang-list" role="listbox" aria-label="Language">
        @for (lang of themeSettings.languages; track lang.code) {
        <li>
          <button type="button" role="option" class="ui-lang-item" [class.is-active]="themeSettings.language() === lang.code"
            [attr.aria-selected]="themeSettings.language() === lang.code" (click)="chooseLanguage(lang.code, languageMenu)">
            <span class="ui-lang-item-flag"><img [src]="lang.flag" [alt]="lang.name + ' flag'" /></span>
            <span class="ui-lang-item-name">{{ lang.name }}</span>
          </button>
        </li>
        }
      </ul>
    </p-popover>
    <button type="button" class="layout-topbar-action" (click)="layoutService.toggleTheme()"
      [attr.aria-label]="layoutService.isDarkTheme() ? 'Light mode' : 'Dark mode'"
      [title]="layoutService.isDarkTheme() ? 'Light mode' : 'Dark mode'">
      <i [class]="layoutService.isDarkTheme() ? 'pi pi-sun' : 'pi pi-moon'"></i>
    </button>
    <button type="button" class="layout-topbar-action topbar-fullscreen" appFullscreen (click)="toggleFullscreen()"
      aria-label="Full screen" title="Full screen">
      <i [class]="isFullscreen ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"></i>
    </button>

    @if (currentUser()) {
    <button #accountButton type="button" class="ui-profile" (click)="account.toggle($event)"
      aria-label="Account" aria-haspopup="true" [attr.aria-expanded]="account.overlayVisible" [title]="displayName()">
      <span class="ui-profile-avatar" aria-hidden="true">{{ initials() }}</span>
      <span class="ui-profile-text">
        <span class="ui-profile-name">{{ displayName() }}</span>
        <span class="ui-profile-role">{{ primaryRoles()[0] }}</span>
      </span>
      <i class="pi pi-angle-down ui-profile-caret" aria-hidden="true"></i>
    </button>
    <p-popover #account appendTo="body" styleClass="ui-account-panel" (onShow)="pointAt(accountButton)">
      <div class="ui-account">
        <div class="ui-account-head">
          <span class="ui-avatar" aria-hidden="true">{{ initials() }}</span>
          <div class="min-w-0">
            <div class="ui-account-name">{{ displayName() }}</div>
            <div class="ui-account-email">{{ currentUser()?.email }}</div>
          </div>
        </div>
        <ul class="ui-account-facts">
          <li>
            <i class="pi pi-id-card" aria-hidden="true"></i>
            <span class="ui-account-roles">
              @for (role of primaryRoles(); track role) {
              <span class="role-chip">{{ role }}</span>
              }
            </span>
          </li>
        </ul>
        <div class="ui-account-actions flex flex-col gap-2">
          <p-button label="Sign out" icon="pi pi-sign-out" styleClass="w-full ui-signout" (onClick)="logout()" />
        </div>
      </div>
    </p-popover>
    }

    <button type="button" class="layout-topbar-action ui-gear-btn" (click)="layoutService.openSettings()"
      aria-label="Settings" title="Settings">
      <i class="bx bx-cog ui-gear" aria-hidden="true"></i>
    </button>
  </div>
</div>
<!-- End::Header -->

<p-dialog header="Search" [(visible)]="searchOpen" [modal]="true" [dismissableMask]="true" [draggable]="false"
  styleClass="search-dialog" [style]="{ width: '36rem', maxWidth: '94vw' }" (onHide)="clearSearch()">
  <!-- Searches the pages of the left-hand menu and the organizations (by name or code). -->
  <div class="ui-search">
    <span class="ui-search-field">
      <i class="pi pi-search" aria-hidden="true"></i>
      <input type="search" class="ui-search-input" placeholder="Search pages and organizations"
        aria-label="Search pages and organizations" [(ngModel)]="text" (input)="Search(text)" autocomplete="off" />
    </span>

    @if (menuItems && menuItems.length > 0) {
    <p class="ui-search-heading">Pages</p>
    <ul class="ui-search-list">
      @for (menuItem of menuItems; track $index) {
      <li>
        <button type="button" class="ui-search-row" (click)="openSearchResult(menuItem?.path)">
          <i class="pi pi-angle-right" aria-hidden="true"></i>
          <span class="truncate">{{ menuItem?.title }}</span>
        </button>
      </li>
      }
    </ul>
    }

    @if (organizationResults.length > 0) {
    <p class="ui-search-heading">Organizations</p>
    <ul class="ui-search-list">
      @for (organization of organizationResults; track organization.id) {
      <li>
        <button type="button" class="ui-search-row" (click)="openOrganization(organization)">
          <i class="pi pi-building" aria-hidden="true"></i>
          <span class="truncate">{{ organization.name }}</span>
          <span class="ui-search-code">{{ organization.code }}</span>
        </button>
      </li>
      }
    </ul>
    }

    @if (organizationsLoading) {
    <p class="search-hint">Searching organizations…</p>
    } @else if (SearchResultEmpty) {
    <p class="search-hint">Nothing found for “{{ text }}”. Try a page name or an organization name or code.</p>
    } @else if (!text) {
    <div class="search-hint"><span>Search a page or an organization, for example</span> <button type="button"
        class="search-example" (click)="text = 'Country'; Search(text)">Country</button> <button type="button"
        class="search-example" (click)="text = 'Module Matrix'; Search(text)">Module Matrix</button> <button
        type="button" class="search-example" (click)="text = 'ORG-1001'; Search(text)">ORG-1001</button></div>
    }
  </div>
</p-dialog>
